/* ============================================================
   Auth types mirroring backend AuthDtos.cs
   ============================================================ */

/** Mirrors AuthResponseDto from the API (POST /auth/login|register|refresh). */
export interface AuthResponse {
  accessToken: string;
  refreshToken: string;
  /** ISO 8601 UTC string, e.g. "2026-08-16T05:52:00Z". */
  expiresAtUtc: string;
  userId: string;
  displayName: string;
  /** "Customer" | "Provider" | "Admin" (backend UserRole enum). */
  role: string;
}

export interface LoginRequest {
  email: string;
  password: string;
}

export interface RegisterRequest {
  email: string;
  password: string;
  displayName: string;
  city: string;
  /** 2f9c70ba: stashed ?ref= code / slug for signup attribution. */
  refCode?: string;
}

/** Mirrors ProfileDto from the API (GET /api/v1/me, CB-1). */
export interface Profile {
  email: string;
  displayName: string;
  phoneNumber: string | null;
  city: string;
  role: string;
  balance: number;
  /** ISO 8601 UTC string or null. */
  lastLoginAtUtc: string | null;
}

/** PUT /api/v1/me — undefined fields keep current values; empty phone clears it. */
export interface UpdateProfileRequest {
  displayName?: string;
  phoneNumber?: string;
}

/** POST /api/v1/me/password. */
export interface ChangePasswordRequest {
  currentPassword: string;
  newPassword: string;
}

/** Russian labels for backend UserRole values. */
export const ROLE_LABELS: Record<string, string> = {
  Customer: 'Заказчик',
  Provider: 'Исполнитель',
  Manager: 'Менеджер',
  Admin: 'Администратор',
};
